import { CAP_COMPLETED, READY_FOR_CAP } from "src/utils/data/job";

// disable submit button for CAP Manager based on job overall cap status
export const CAP_MANAGER_CAP_DISABLE_STATUS = ['cap_submission_pending', 'cap_revision_request', 'cap_approved', 'cap_remediation_underway', 'cap_process_complete', 'cap_process_complete_all_findings_closed', 'cap_process_complete_on_site_verification_pending'];

// disable submit button for external user based on job overall cap status 
export const EXTERNAL_USER_CAP_DISABLE_STATUS = ['cap_review_pending', 'cap_approved', 'cap_evidence_review_pending', 'cap_process_complete', 'cap_process_complete_all_findings_closed', 'cap_process_complete_on_site_verification_pending'];

export const OVERALL_STATUS_OPTIONS = [
    { label: `CAP Submission Pending`, value: 'cap_submission_pending'},
    { label: `CAP Review Pending`, value: 'cap_review_pending'},
    { label: `CAP Process Complete - All findings closed`, value: 'cap_process_complete_all_findings_closed'},
    { label: `CAP Process Complete`, value: 'cap_process_complete'},
    { label: `CAP Revision Request`, value: 'cap_revision_request'},
    { label: `Evidence Review Pending`, value: 'cap_evidence_review_pending'},
    { label: `Remediation Underway`, value: 'cap_remediation_underway'},
    { label: `CAP Process Complete - On site verification pending`, value: 'cap_process_complete_on_site_verification_pending'},
    { label: `CAP Approved`, value: 'cap_approved'},
  ];

export const wasCapSaved = (findings) => {
  // If saved at is greater than submitted at in any of the findings or action then keep submit button enabled
  return findings?.findings.some((finding) => {
    return (new Date(finding.savedAt) > new Date(finding.submittedAt)) || finding.actions.some(({savedAt, submittedAt}) => new Date(savedAt) > new Date(submittedAt));
  });
};

export const shouldDisableSave = (
  isExternalUser, 
  isAdmin,
  isCAP,
  isDirty,
  overallCapStatusValue
) => {
  if (isExternalUser) {
    return (!isAdmin && isExternalUser && (EXTERNAL_USER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) || (!EXTERNAL_USER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) && !isDirty)));
  }
  return (!isAdmin && isCAP && (CAP_MANAGER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) || (!CAP_MANAGER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) && !isDirty)));
};

export const shouldDisableSubmit = (
  isExternalUser,
  isAdmin,
  isCAP,
  overallCapStatusValue,
  wasSavedBefore,
) => {
  if (isExternalUser) {
    return (!isAdmin && isExternalUser && (EXTERNAL_USER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) || (!EXTERNAL_USER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) && 
    !wasSavedBefore)));
  }
  return (!isAdmin && isCAP && (!overallCapStatusValue || CAP_MANAGER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) || (!CAP_MANAGER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) && !wasSavedBefore)));
};

export const shouldDisableClientIdInput = (
  isExternalUser,
  isAdmin,
  isCAPManager,
  overallCapStatusValue,
  jobStatus
)=>{
  if(jobStatus === CAP_COMPLETED || jobStatus === READY_FOR_CAP){
    return true;
  }

  if (isCAPManager || isAdmin) {
      return (isCAPManager 
          ? CAP_MANAGER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) 
          : false);
  }
  return (isExternalUser 
          ? EXTERNAL_USER_CAP_DISABLE_STATUS.includes(overallCapStatusValue) 
          : true);
}
